import { Box, ButtonBase, Typography, useTheme } from '@mui/material'
import React from 'react'
import {customTheme} from '../customTheme'
import { WEEK_DAY } from '../constant'

export const DateDisplay = ({ text, level = 1 }) => {
  const theme = useTheme()
  if (!text) {
    return null
  }
  const datetime = new Date(text)
  return (
    <Box>
      <Typography sx={{
        color: theme.palette.text.primary,
        pl: 1,
        py: 0.5,
        fontSize: '1rem',
        fontWeight: 600,
        letterSpacing: '0.5px',
      }}>
        {datetime.getMonth() + 1}月{datetime.getDate()}日
        &nbsp;
        {WEEK_DAY[datetime.getDay()]}
      </Typography>
    </Box>
  )
}

export const TimeDisplay = ({ text }) => {
  if (!text) {
    return null
  }
  const datetime = new Date(text)
  const hours = String(datetime.getHours()).padStart(2, '0');
  const minutes = String(datetime.getMinutes()).padStart(2, '0');
  return (
    <Typography color="text.primary">
      {hours}:{minutes}
    </Typography>
  )
}

export const CustomTitleField = ({ text, level = 1 }) => {
  const fontSize = 18 - level * 2
  const paddingLeft = `${2 * (level - 1)}em`
  const sx = {
    fontSize: fontSize,
    paddingLeft: paddingLeft,
    fontWeight: level === 1 ? 'bold' : 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // whiteSpace: 'nowrap',
  }
  return (
    <Typography ellipsis={true} style={sx}> {text} </Typography>
  )
}

export const CustomContentField = ({ text, level = 1 }) => {
  const fontSize = 18 - level * 2
  const paddingLeft = `${2 * (level - 1)}em`
  const sx = {
    fontSize: fontSize,
    paddingLeft: paddingLeft,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // whiteSpace: 'nowrap',
  }
  return (
    <Typography ellipsis={true} style={sx}> {text} </Typography>
  )
}

export const ColoredNumberField = ({ text, fontSize = 18, bold = true }) => {
  const theme = customTheme
  const isDarkMode = theme.palette.mode === 'dark'

  // 收入红色、支出绿色
  const incomeColor = isDarkMode ? '#ff6b6b' : '#e53935'
  const expenseColor = isDarkMode ? '#66bb6a' : '#43a047'

  const sx = {
    fontSize: fontSize,
    fontWeight: bold ? 700 : 500,
    display: 'flex',
    alignItems: 'center',
    textAlign: 'right',
    fontFamily: '"SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    letterSpacing: '-0.3px',
  }

  return text > 0 ? (
    <Typography sx={{ color: incomeColor, ...sx }}>
      +{text.toFixed(2)}
    </Typography>
  ) : (
    text < 0 ? (
      <Typography sx={{ color: expenseColor, ...sx }}>
        {text.toFixed(2)}
      </Typography>
    ) : (
      <Typography sx={{ fontSize, color: 'text.secondary', ...sx }}>
        {text.toFixed(2)}
      </Typography>
    )
  )
}